module.exports = __webpack_public_path__ + "static/img/bcg_k5.c4656c02.png";